import type { HTMLAttributes } from 'react';
import { Wrapper } from './SectionTitle.styles';
import type { SectionTitleType } from './types';

type SectionTitleProps = {
  text?: string;
  type?: SectionTitleType;
} & Pick<HTMLAttributes<HTMLSpanElement>, 'className'>;

const SectionTitle = ({
  text,
  type = 'default',
  className,
}: SectionTitleProps) => {
  if (!text) {
    return null;
  }

  return (
    <Wrapper sectionTitleType={type} className={className}>
      {text}
    </Wrapper>
  );
};

export { SectionTitle };
